import type {
  GetCsHighlightPageRequest,
  GetCsHighlightPageResponse,
} from "@/modules/api/generated-types/jobteaser/cs_highlight/v1alpha1/cs_highlight"
import type { NextRequest } from "@/modules/fetch/types"
import type { ObjectToCamel } from "@/modules/format/types"
import type { I18nLocale } from "@/modules/i18n/types"

import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

import { CS_SPOTLIGHT_GET_PAGE_ENDPOINT } from "./endpoints"

type GetCsSpotlightPageParams = {
  careerCenterId: string
  locale: I18nLocale
  preview?: boolean
  req?: NextRequest
}

type GetCsSpotlightPageResponse = ObjectToCamel<GetCsHighlightPageResponse> | null

export const getCsSpotlightPage = async ({
  careerCenterId,
  locale,
  preview = false,
  req,
}: GetCsSpotlightPageParams): Promise<GetCsSpotlightPageResponse> => {
  const payload: GetCsHighlightPageRequest = {
    locale,
    published: !preview,
    school_id: careerCenterId,
  }

  return fetcher(CS_SPOTLIGHT_GET_PAGE_ENDPOINT, {
    nextRequest: req,
    requestInit: {
      body: JSON.stringify(payload),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
    storageKey: `cs-highlight-page::${careerCenterId}::${preview}`,
  })
    .then(async response => {
      const results = await response.json()

      if (results.error) {
        return null
      }

      return toCamelCaseKeys<GetCsHighlightPageResponse>(results)
    })
    .catch(handleFetchError(CS_SPOTLIGHT_GET_PAGE_ENDPOINT))
}
